import Service from './service';
import { AxiosResponse } from 'axios';
import { updateUserType, User } from 'interfaces/user';
import { acceptTermsAndConditions, updateUser, userQuery, updateTrialUser } from './rtsproUser.query';

const Config = require('Config');

export class RtsProUsersService extends Service {
  constructor() {
    super(Config.rtsproUsersServiceUrl);
  }

  async getUserByEmail(email): Promise<{ user: User }> {
    const url = `/`;

    const body = {
      ...userQuery,
      variables: {
        email,
      },
    };

    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async updateUser(user, changed): Promise<{ updateUser: updateUserType }> {
    const url = '/';

    const body = {
      ...updateUser,
      variables: {
        user,
        changed,
      },
    };

    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async updateTrialUser(
    email: string,
    changed?: Partial<updateUserType> & { trialExtensionRequested?: boolean },
  ): Promise<{ updateTrialUser: updateUserType }> {
    const url = '/';

    const body = {
      ...updateTrialUser,
      variables: {
        email,
        changed,
      },
    };

    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }

  async acceptTermsAndConditions(email: string, terms: { acceptedFrom: string; termsType: string }) {
    const url = '/';

    const body = {
      ...acceptTermsAndConditions,
      variables: {
        email,
        terms,
      },
    };

    const response: AxiosResponse = await this.axios.post(url, body);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data;
  }
}

export default new RtsProUsersService();
